import ReactGA from "react-ga4";

export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined" || !GA_MEASUREMENT_ID) return;
  ReactGA.initialize(GA_MEASUREMENT_ID, {
    gtagOptions: { send_page_view: false },
  });
  initialized = true;
}

export function trackPageView({ pathname, search }) {
  if (!initialized || typeof window === "undefined") return;
  ReactGA.gtag("event", "page_view", {
    page_title: document.title,
    page_location: `${window.location.origin}${pathname}${search}`,
  });
}

export function trackEvent(name, params = {}) {
  if (!initialized) return;
  ReactGA.event(name, params);
}
